import type { VaultStatus } from '@/data/types';

export const DOC_TYPE_LABEL: Record<string, string> = {
  strategy: 'Strategy', brand_guide: 'Brand guide', contract: 'Contract', proposal: 'Proposal', account_info: 'Account info',
  meeting_notes: 'Meeting notes', report: 'Report', correspondence: 'Correspondence', other: 'Document',
};
export const STATUS_LABEL: Record<VaultStatus, string> = {
  queued: 'Waiting', processing: 'Reading…', ready: 'Ready', failed: 'Failed', unsupported: 'Not readable', removed: 'Removed',
};
export const fileSize = (n: number | null) =>
  n == null ? '' : n < 1024 ? `${n} B` : n < 1048576 ? `${Math.round(n / 1024)} KB` : `${(n / 1048576).toFixed(1)} MB`;

/** What a person labelled the document; falls back to the AI summary's type. */
export const LABEL: Record<string, string> = {
  transcript: 'Transcript', proposal: 'Proposal', strategy: 'Strategy', contract: 'Contract', brand: 'Brand', notes: 'Notes', other: 'Other',
};
export const LABEL_OPTIONS = Object.entries(LABEL).map(([value, label]) => ({ value, label }));
